module.exports = __webpack_public_path__ + "static/media/IMG_5084.03720486.PNG";